/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Self_Bought_TagInputs */

const vi_care_log_self_bought_tag = /** @type {(inputs: Care_Log_Self_Bought_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(hộ tự mua)`)
};

/**

* @param {Care_Log_Self_Bought_TagInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_self_bought_tag = /** @type {((inputs?: Care_Log_Self_Bought_TagInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Self_Bought_TagInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_self_bought_tag(inputs)
});